var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form',{attrs:{"form":_vm.form},on:{"submit":_vm.handleSubmit}},[_c('a-form-item',[_c('a-textarea',{directives:[{name:"decorator",rawName:"v-decorator",value:(['description', {
        initialValue: _vm.formData.description || ''
    }]),expression:"['description', {\n        initialValue: formData.description || ''\n    }]"}]})],1),_c('a-form-item',[_c('a-button',{attrs:{"type":"primary"},on:{"click":function () { return _vm.changeFieldValue(_vm.form, {
                  tblname: 'stadium',
                  fieldname: 'description',
                  fieldlabel: '公告',
                  isRequired: true,
                  content: '修改场馆公告',
                  primaryname: 'id',
                  primaryval: _vm.stadiumId,
                  oldval: _vm.formData.description
                }, 'admin-stadiums-edit'); }}},[_vm._v("保存")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }